import { resolveError } from 'lib/utils/formatters/error/resolve-error';
import { PostExecutionCallbacks } from '../../_components/questionnaire-paginator-types';

/**
 * Helper method to add onSuccess and onError event callbacks to submission
 * events that are invoked through the legacy questionnaire state management design
 * @param callbacks
 * @param originalMethod
 * @returns
 */
export async function controlflowSubmissionEventHandler<T>(
  callbacks: PostExecutionCallbacks,
  originalMethod: () => Promise<T>
) {
  try {
    const data = await originalMethod();
    callbacks.onSuccess();
    return data;
  } catch (e) {
    callbacks.onError(resolveError(e));
    throw e;
  }
}
